module.exports = __webpack_public_path__ + "static/media/whitelogo.acaaa640.png";